import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDeactivateCountryData {
  countryName: string;
  countryCode: string;
}

@Component({
  selector: 'app-confirm-deactivate-country-dialog',
  templateUrl: './confirm-deactivate-country-dialog.component.html',
  styleUrls: ['./confirm-deactivate-country-dialog.component.sass'],
})
export class ConfirmDeactivateCountryDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDeactivateCountryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDeactivateCountryData,
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
